module.exports = __webpack_public_path__ + "img/Insanity.17a46b6d.png";